import {Component} from '@angular/core';
import {StartupService} from "../../service-ui/startup.service";
import {LanguagePipe} from "../../pipe/language.pipe";

@Component({
  selector: 'app-active-role',
  templateUrl: './active-role.component.html',
  styleUrls: ['./active-role.component.css']
})

export class ActiveRoleComponent {

  constructor (public startupService: StartupService) {
    this.startupService.touchLastUserActivity();
  }

  /**
   * `selectedRoleName` is either an organization's display name or —
   * when the operator picked a role from `SelectRoleComponent`, which
   * passes `roleId` through as the name — a bare role id.
   *
   * Only the bare-id case gets the locale digit table applied. Running
   * it unconditionally would rewrite digits inside real organization
   * names ("Press 24" → "Press ٢٤"), which is a proper noun the
   * customer chose, not a quantity the UI is presenting.
   */
  get displayRoleName(): string {
    const name = this.startupService.selectedRoleName;
    if (!name) { return ''; }
    return /^[0-9]+$/.test('' + name) ? LanguagePipe.localizeNumber(name) : name;
  }
}


